/*
 * Merchant: "for the full manifest don't put the newest items first" — the
 * default sort ("Newest Intake") meant every big Collective import (today
 * it was Books, then Knives, then whatever comes next) briefly buries the
 * whole rest of the catalog at the bottom the moment it lands. Replaces
 * that default with a genuinely random order instead, at the merchant's
 * choice over two other options (oldest-era-first, price-low-to-high) —
 * neither one is safe either: "Oldest Era" would put every one of today's
 * new-department items (no custom.era set) at the very front instead,
 * since blank sorts before any real era string.
 *
 * Loads last (after assets/sat-modern-department-patch.js), wrapping
 * whatever SATComponent.prototype.visibleProducts currently resolves to —
 * so this applies to every department's listing, built-in or added by that
 * patch, not just one of them. storeItems (snippets/sat-manifest.liquid's
 * "Full Manifest" grid, The Southern Air Import's own grid, and the home
 * page teaser) all read from this same method (see sat-app.js renderVals,
 * `storeItems: ... this.visibleProducts() ...`), so one wrap here covers
 * all three.
 *
 * Renamed the dropdown option itself too (renderVals's sortOptions) —
 * leaving it reading "Newest Intake" while it actually shuffles would be
 * lying to whoever opens that dropdown expecting literal newest-first.
 * The three other real sort modes (Price Low-High, Price High-Low, Oldest
 * Era) are untouched and still do exactly what they say.
 *
 * The shuffle order is stable per page load, not re-randomized on every
 * render — each product's position is decided once (a random key cached
 * the first time that id is seen) and reused for every subsequent render,
 * so the grid doesn't visibly jitter while someone is just typing in the
 * search box or opening the cart. A fresh page load gets a fresh order.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var RANDOM_LABEL = 'Newest Intake'; // kept as the underlying state value on purpose — nothing else in the app keys off this exact string besides the 3 explicit sort branches this patch and the base build already skip for it; only the dropdown's displayed text changes, below.
  var DISPLAY_LABEL = 'Random';
  var EXPLICIT_SORTS = ['Price, Low to High', 'Price, High to Low', 'Oldest Era'];

  var shuffleKeys = {};
  function shuffleKeyFor(id) {
    if (!(id in shuffleKeys)) { shuffleKeys[id] = Math.random(); }
    return shuffleKeys[id];
  }

  var proto = window.SATComponent.prototype;

  var origVisibleProducts = proto.visibleProducts;
  proto.visibleProducts = function () {
    var list = origVisibleProducts.call(this);
    if (EXPLICIT_SORTS.indexOf(this.state.sortBy) !== -1) { return list; }
    return list.slice().sort(function (a, b) { return shuffleKeyFor(a.id) - shuffleKeyFor(b.id); });
  };

  var origRenderVals = proto.renderVals;
  proto.renderVals = function () {
    var out = origRenderVals.call(this);
    if (Array.isArray(out.sortOptions)) {
      out.sortOptions = out.sortOptions.map(function (label) {
        return label === RANDOM_LABEL ? DISPLAY_LABEL : label;
      });
    }
    // The <select>'s bound value (snippets/sat-import.liquid) has to match
    // one of the option values above exactly, or the browser just falls
    // back to whichever <option> happens to be first in the DOM — right by
    // coincidence today (Random still sits first), but not something to
    // depend on. Normalize it explicitly instead.
    if (out.sortBy === RANDOM_LABEL) { out.sortBy = DISPLAY_LABEL; }
    return out;
  };
})();
